import { render } from "./MunicipalitiesMenu.vue?vue&type=template&id=7fdcc0ee"
const script = {}

import "./MunicipalitiesMenu.vue?vue&type=style&index=0&id=7fdcc0ee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__